<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-form-stack" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-select [itemsSource]="dataTypes" [control]="form.controls['dataType']" [helpText]="'CUSTOM_PROPERTY.HELP.DATATYPE'"></astral-select>
        </astral-layout-group>
        @if (showSelection) {
          <astral-textarea
            [control]="form.controls['selectableValues']"
            [helpText]="'CUSTOM_PROPERTY.HELP.SELECTION'"
            [rows]="6"
          ></astral-textarea>
        }
        @if (showNumeric) {
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [itemsSource]="decimals" [control]="form.controls['decimalCount']" [helpText]="'CUSTOM_PROPERTY.HELP.DECIMALS'"></astral-select>
            <astral-select [itemsSource]="units" [control]="form.controls['unit']" [helpText]="'ARTICLE.HELP_TEXT.UNIT'"></astral-select>
            <astral-input type="number" [control]="form.controls['minValue']" [helpText]="'CUSTOM_PROPERTY.HELP.MINVALUE'"></astral-input>
            <astral-input type="number" [control]="form.controls['maxValue']" [helpText]="'CUSTOM_PROPERTY.HELP.MAXVALUE'"></astral-input>
          </astral-layout-group>
        }
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
          <astral-toggle [control]="form.controls['availableOnCompany']" [helpText]="'CUSTOM_PROPERTY.HELP.AVAILABLE_ON_COMPANY'"></astral-toggle>
          <astral-toggle [control]="form.controls['availableOnProperty']" [helpText]="'CUSTOM_PROPERTY.HELP.AVAILABLE_ON_PROPERTY'"></astral-toggle>
          <astral-toggle [control]="form.controls['availableOnBuilding']" [helpText]="'CUSTOM_PROPERTY.HELP.AVAILABLE_ON_BUILDING'"></astral-toggle>
          <astral-toggle [control]="form.controls['availableOnDwelling']" [helpText]="'CUSTOM_PROPERTY.HELP.AVAILABLE_ON_DWELLING'"></astral-toggle>
          <astral-toggle [control]="form.controls['availableOnPremises']" [helpText]="'CUSTOM_PROPERTY.HELP.AVAILABLE_ON_PREMISES'"></astral-toggle>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
